import { render, staticRenderFns } from "./ProvidedHealthServices.vue?vue&type=template&id=9df91892&"
import script from "./ProvidedHealthServices.vue?vue&type=script&lang=js&"
export * from "./ProvidedHealthServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports